if (!customElements.get('video-popup')) {
  class VideoPopup extends HTMLElement {
    constructor() {
      super();
      this.overlay = null;
      this.boundOpen = this.open.bind(this);
      this.boundClose = this.close.bind(this);
    }

    connectedCallback() {
      this.trigger = this.querySelector('.video-popup__trigger');
      this.desktopTemplate = this.querySelector('.video-popup__tpl-desktop');
      this.mobileTemplate = this.querySelector('.video-popup__tpl-mobile');
      this.mobileQuery = window.matchMedia('(max-width: 768px)');

      if (this.trigger) {
        this.trigger.addEventListener('click', this.boundOpen);
      }

      this.injectPreview();
    }

    injectPreview() {
      const container = this.querySelector('[data-vp-preview]');
      if (!container) return;

      const desktop = this.getMarkup(this.querySelector('.video-popup__preview-tpl-desktop'));
      const mobile = this.getMarkup(this.querySelector('.video-popup__preview-tpl-mobile'));
      const html = this.mobileQuery.matches && mobile !== '' ? mobile : desktop;
      if (html) {
        container.innerHTML = html;
      }
    }

    disconnectedCallback() {
      this.close();
    }

    getMarkup(el) {
      if (!el) return '';
      // Markup is stored in inert <script type="text/template"> holders, so the
      // raw embed (iframes, self-closing tags) survives untouched until injected.
      const raw = el.tagName === 'TEMPLATE' ? el.innerHTML : el.textContent;
      return raw.trim();
    }

    pickMarkup() {
      const mobile = this.getMarkup(this.mobileTemplate);
      if (this.mobileQuery.matches && mobile !== '') {
        return mobile;
      }
      return this.getMarkup(this.desktopTemplate);
    }

    buildOverlay() {
      const overlay = document.createElement('div');
      overlay.className = 'video-popup-modal';
      overlay.innerHTML = `
        <div class="video-popup-modal__content">
          <button type="button" class="video-popup-modal__close" aria-label="Close video">
            <span aria-hidden="true">
              <svg width="21" height="21" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 12H19" stroke="#183B3F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                <path d="M12 5L19 12L12 19" stroke="#183B3F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
            </span>
            <span>Back</span>
          </button>
          <div class="video-popup-modal__media"></div>
        </div>`;

      overlay.addEventListener('click', (event) => {
        if (event.target === overlay) {
          this.close();
        }
      });
      overlay.querySelector('.video-popup-modal__close').addEventListener('click', this.boundClose);

      return overlay;
    }

    open(event) {
      if (event) event.preventDefault();
      if (this.overlay) return;

      const html = this.pickMarkup();
      if (!html) return;

      this.overlay = this.buildOverlay();
      const media = this.overlay.querySelector('.video-popup-modal__media');
      media.innerHTML = html;

      const maxWidth = this.dataset.maxWidth;
      if (maxWidth) {
        media.style.width = `min(${maxWidth}px, 90vw)`;
      }

      // Preserve the embed's own aspect ratio when its dimensions are known.
      const embed = media.querySelector('iframe, video');
      if (embed) {
        const width = parseFloat(embed.getAttribute('width'));
        const height = parseFloat(embed.getAttribute('height'));
        if (width && height) {
          media.style.aspectRatio = `${width} / ${height}`;
        }
        embed.removeAttribute('width');
        embed.removeAttribute('height');
      }

      document.body.appendChild(this.overlay);
      document.body.style.overflow = 'hidden';
    }

    close() {
      if (!this.overlay) return;
      // Removing the overlay tears down the iframe/video element, stopping playback.
      this.overlay.remove();
      this.overlay = null;
      document.body.style.overflow = '';
    }
  }

  customElements.define('video-popup', VideoPopup);
}
